import PropTypes from 'prop-types'
import React from 'react'

const ReadingTime = ({ words }) => {
  let time = Math.round(words / 200)
  if (time === 0) time = 1
  return <span> • {time} min read</span>
}

ReadingTime.propTypes = {
  words: PropTypes.number
}

export default ReadingTime



// WEBPACK FOOTER //
// ./src/components/ReadingTime/ReadingTime.js